import { entidadesModuleRoutes } from './../../modules/entidades.module';
import { AppComponent } from './../../app.component';
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { DiagnosticoService } from '../../providers/diagnostico/diagnostico.service';
import { allSettled } from 'q';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosStatsProvider } from '../../providers/web-service-service/servicios-stats';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService } from 'ng2-translate';
import { environment } from '../../../environments/environment';

@Component({
  templateUrl: './BreezeTest.component.html',
  styles: [`
      .cars-datalist ul {
          margin: 0;
          padding: 0;
      }

      @media (max-width:640px) {
          .cars-datalist .text-column {
              text-align: center;
          }
      }
  `],
  styleUrls: ['./BreezeTest.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class BreezeTestComponent implements OnInit {
	spinner: HTMLElement;

	selectorImagenModelo: any;
	modeloSeleccionada: any;
	urlModeloSeleccionada: string;

	selectorImagenPlano: any;
	planoSeleccionada: any;
	urlPlanoSeleccionada: string;
	selectorImagen: any;
	ImagenSeleccionada: any;

	constructor(
		private appComponent: AppComponent,
		public DIAG: DiagnosticoService,
		public authenticationService: AuthenticationService,
		public entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public STAT: ServiciosStatsProvider,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService
	) {
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('MenuLateral.Diagnostico') }
		]);
	}

	ngOnInit() {
		window.scroll(0, 0);
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

	}


/* CONEXIONES_NODO */
	comprobarConexiones(){
		const that = this;
		this.spinner.style.display = 'inherit';
		this.DIAG.pintarDiagnosticoCONEXIONES_NODOs()
		.then(function (){
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.spinner.style.display = 'none';

			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}

/* MIGRAR BASES de DATOS */
	migrarEstadisticas(){
		const idEntidad = this.authenticationService.getIdEntidad();
		const token = this.authenticationService.getToken();
		this.STAT.migrarBDStat(token, idEntidad);
	}

	migrarBD_IT_EVERPATHS(){
		const token = this.authenticationService.getToken();
		const that = this;
		this.spinner.style.display = 'inherit';
		this.sws.wsMigrarBD(token).toPromise()
		.then(function(Initialized){
			that.spinner.style.display = 'none';
			that.DIAG.limpiar('BreezeBody');
			that.DIAG.escribir(1, 'BD_IT', 'BreezeBody');
			that.DIAG.escribir(1, '-------------------------------------------', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, Initialized, 'BreezeBody');
		})
		.catch(function(e){
			that.spinner.style.display = 'none';

			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
		this.appComponent.showWarn('mensaje', 'Migrar BD_IT automaticamente, Proximamente ...');
	}

	migrarBBDD_EVERPATHS(){
		const that = this;
		this.spinner.style.display = 'inherit';
		return this.sws.wsMigrarBBDD().toPromise()
		.then(function (Initialized){
			that.spinner.style.display = 'none';
			that.DIAG.limpiar('BreezeBody');

			Initialized.lista.forEach(element => {
				that.DIAG.escribir(1, 'BASE DE DATOS: ' + element, 'BreezeBody');
			});
		})
		.catch(function(e){
			that.spinner.style.display = 'none';

			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}

	migrarBD_EVERPATHS(){
		const that = this;
		const token = this.authenticationService.getToken();
		const idEntidad = this.authenticationService.getIdEntidad();
		this.spinner.style.display = 'inherit';
		return this.sws.wsMigrarBD(token, idEntidad).toPromise()
		.then(function (Initialized) {
			that.spinner.style.display = 'none';
			that.DIAG.limpiar('BreezeBody');
			that.DIAG.escribir(1, 'BASE DE DATOS: ' + idEntidad, 'BreezeBody');
			that.DIAG.escribir(1, '-------------------------------------------', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, Initialized, 'BreezeBody');
		})
		.catch(function(e){
			that.spinner.style.display = 'none';

			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}


/* CONTENIDO */
	comprobarContenidos(){
		const that = this;
		this.spinner.style.display = 'inherit';
		return this.DIAG.pintarDiagnosticoCONTENIDOs()
		.then(function (){
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.spinner.style.display = 'none';
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}

	repararContenidos(){
		const that = this;
		this.spinner.style.display = 'inherit';
		this.DIAG.repararContenidos()
		.then(function (){
			that.spinner.style.display = 'none';
		});
	}

	geoposicionarContenidos(){
		const that = this;
		this.spinner.style.display = 'inherit';
		const token = this.authenticationService.getToken();
		let contenidosPosicionar;
		const promises: any[] = [];
		this.entityManager.getCONTENIDO()
		.then(function (contenidos){
			contenidosPosicionar = contenidos;
			for (let index = 0; index < contenidos.length; index++) {
				const cont = contenidos[index];
				promises.push(
					that.sws.wsObtenerLLFromXY(token, cont.X, cont.Y, cont.EspacioPertenencia, cont.IdAlaPlano).toPromise()
					.then(function(LL){
						cont.Latitud = LL.Latitud;
						cont.Longitud = LL.Longitud;
					})
					.catch(function(e){
						that.spinner.style.display = 'none';
						that.DIAG.escribir(1, '.', 'BreezeBody');
						that.DIAG.escribir(1, '.', 'BreezeBody');
						const codigo = e.status;
						that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
					})
				);
			}
			return allSettled(promises);
		})
		.then(function (){
			return that.entityManager.saveChanges();
		})
		.then(function (){
			that.DIAG.limpiar('BreezeBody');
			contenidosPosicionar.forEach(element => {
				that.DIAG.escribir(1, 'Contenido: ' + element.Titulo, 'BreezeBody');
				that.DIAG.escribir(1, '-------------------------------------------', 'BreezeBody');
				that.DIAG.escribir(1, 'X: ' + element.X , 'BreezeBody');
				that.DIAG.escribir(1, 'Y: ' + element.Y , 'BreezeBody');
				that.DIAG.escribir(1, 'Latitud: ' + element.Latitud , 'BreezeBody');
				that.DIAG.escribir(1, 'Longitud: ' + element.Longitud , 'BreezeBody');
				that.DIAG.escribir(1, '.', 'BreezeBody');
			});
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.spinner.style.display = 'none';
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}

	geoposicionarNoodos(){
		const that = this;
		this.spinner.style.display = 'inherit';
		const token = this.authenticationService.getToken();
		let nodoosPosicionar;
		const promises: any[] = [];
		const idEspacioo = this.authenticationService.getIdEspacio();
		this.entityManager.getNODO(undefined, 'SECCION.ALA.NIVEL.ESPACIO')
		.then(function (noodos){
			nodoosPosicionar = noodos;
			for (let index = 0; index < noodos.length; index++) {
				const noodo = noodos[index];
				promises.push(
					that.sws.wsObtenerLLFromXY(token, noodo.X, noodo.Y, idEspacioo, noodo.SECCION.ALA.Id).toPromise()
					.then(function(LL){
						noodo.Latitud = LL.Latitud;
						noodo.Longitud = LL.Longitud;
					})
					.catch(function(e){
						that.spinner.style.display = 'none';
						that.DIAG.escribir(1, '.', 'BreezeBody');
						that.DIAG.escribir(1, '.', 'BreezeBody');
						const codigo = e.status;
						that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
					})
				);
			}
			return allSettled(promises);
		})
		.then(function (){
			return that.entityManager.saveChanges();
		})
		.then(function (){
			that.DIAG.limpiar('BreezeBody');
			nodoosPosicionar.forEach(element => {
				that.DIAG.escribir(1, 'Nodos: ' + element.Nombre, 'BreezeBody');
				that.DIAG.escribir(1, '-------------------------------------------', 'BreezeBody');
				that.DIAG.escribir(1, 'X: ' + element.X , 'BreezeBody');
				that.DIAG.escribir(1, 'Y: ' + element.Y , 'BreezeBody');
				that.DIAG.escribir(1, 'Latitud: ' + element.Latitud , 'BreezeBody');
				that.DIAG.escribir(1, 'Longitud: ' + element.Longitud , 'BreezeBody');
				that.DIAG.escribir(1, '.', 'BreezeBody');
			});
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.spinner.style.display = 'none';
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}

	repararIdiomas(){
		const that = this;
		const token = this.authenticationService.getToken();
		const idEntidad = this.authenticationService.getIdEntidad();
		this.spinner.style.display = 'inherit';
		return this.sws.RepararIdiomas(token, idEntidad).toPromise()
		.then(function(res){
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = res.msg;
			that.DIAG.escribir(0, ' -- Respuesta: ' + codigo, 'BreezeBody');
			that.spinner.style.display = 'none';
		})
		.catch(function(e){
			that.spinner.style.display = 'none';
			that.DIAG.escribir(1, '.', 'BreezeBody');
			that.DIAG.escribir(1, '.', 'BreezeBody');
			const codigo = e.status;
			that.DIAG.escribir(0, ' -- CODIGO ERROR: ' + codigo, 'BreezeBody');
		});
	}


	/* ** Metodos de GroupForm ** */
	onFileSelectModelo($event, fileUploadComponentAla, selector) {
		if (selector === 'modelo3d') {
			const that = this;
			this.selectorImagenModelo = fileUploadComponentAla;
			console.log('$event.files[0] = ' + $event.files[0]);
			this.modeloSeleccionada = $event.files[0];
			this.subirModelo3d(this.modeloSeleccionada)
			.then(function(urlImagen) {
				that.urlModeloSeleccionada = urlImagen;
				console.log("URL_MODELO: " + that.urlModeloSeleccionada);
			});
		}
		if (selector === 'plano') {
			const that = this;
			this.selectorImagenPlano = fileUploadComponentAla;
			console.log('$event.files[0] = ' + $event.files[0]);
			this.planoSeleccionada = $event.files[0];
			this.subirSvgPlano(this.planoSeleccionada)
			.then(function(urlImagen) {
				that.urlPlanoSeleccionada = urlImagen;
				console.log("PLANO: " + that.urlPlanoSeleccionada);
			});
		}
		if (selector === 'imagen') {
			const that = this;
			this.selectorImagen = fileUploadComponentAla;
			console.log('$event.files[0] = ' + $event.files[0]);
			this.ImagenSeleccionada = $event.files[0];
			this.subirFotosCMS(this.ImagenSeleccionada);
		}

	}

	public subirModelo3d(ModeloSeleccionada) {
		if (ModeloSeleccionada) {
			return this.sws.subirFicheroCMS(ModeloSeleccionada, undefined, environment.CMS_3d_model_user_1, environment.CMS_3d_model_token).toPromise();
		}
		else {
			return Promise.resolve('done');
		}
	}
	public subirSvgPlano(plano) {
		if (plano) {
			return this.sws.subirFicheroCMS(plano, undefined, environment.CMS_user_1, environment.CMS_token).toPromise();
		}
		else {
			return Promise.resolve('done');
		}
	}

	public subirFotosCMS(fotoSeleccionada) {
		if (fotoSeleccionada) {
			return this.sws.subirFotosCMS([fotoSeleccionada])
			.then(function(resp) {
				console.log(resp);
			});
		}
		else {
			return Promise.resolve('done');
		}
	}

	/* PRUEBAS IMAGEN Y BASE64
	subirBase64(b64, nombre, tipo) {
		if (!b64) {
			b64 = "//48AD8AeABtAGwAIAB2AGUAcgBzAGkAbwBuAD0AIgAxAC4AMAAiACAAZQBuAGMAbwBkAGkAbgBnAD0AIgBVAFQARgAtADEANgAiAD8APgANAAoAPAAhAEQATwBDAFQAWQBQAEUAIABzAHYAZwAgAFAAVQBCAEwASQBDACAAIgAtAC8ALwBXADMAQwAvAC8ARABUAEQAIABTAFYARwAgADEALgAxAC8ALwBFAE4AIgAgACIAaAB0AHQAcAA6AC8ALwB3AHcAdwAuAHcAMwAuAG8AcgBnAC8ARwByAGEAcABoAGkAYwBzAC8AUwBWAEcALwAxAC4AMQAvAEQAVABEAC8AcwB2AGcAMQAxAC4AZAB0AGQAIgA+AA0ACgA8ACEALQAtACAAQwByAGUAYQB0AG8AcgA6ACAAQwBvAHIAZQBsAEQAUgBBAFcAIABYADcAIAAtAC0APgANAAoAPABzAHYAZwAgAHgAbQBsAG4AcwA9ACIAaAB0AHQAcAA6AC8ALwB3AHcAdwAuAHcAMwAuAG8AcgBnAC8AMgAwADAAMAAvAHMAdgBnACIAIAB4AG0AbAA6AHMAcABhAGMAZQA9ACIAcAByAGUAcwBlAHIAdgBlACIAIAB3AGkAZAB0AGgAPQAiADMANQBwAHgAIgAgAGgAZQBpAGcAaAB0AD0AIgAzADUAcAB4ACIAIAB2AGUAcgBzAGkAbwBuAD0AIgAxAC4AMQAiACAAcwB0AHkAbABlAD0AIgBzAGgAYQBwAGUALQByAGUAbgBkAGUAcgBpAG4AZwA6AGcAZQBvAG0AZQB0AHIAaQBjAFAAcgBlAGMAaQBzAGkAbwBuADsAIAB0AGUAeAB0AC0AcgBlAG4AZABlAHIAaQBuAGcAOgBnAGUAbwBtAGUAdAByAGkAYwBQAHIAZQBjAGkAcwBpAG8AbgA7ACAAaQBtAGEAZwBlAC0AcgBlAG4AZABlAHIAaQBuAGcAOgBvAHAAdABpAG0AaQB6AGUAUQB1AGEAbABpAHQAeQA7ACAAZgBpAGwAbAAtAHIAdQBsAGUAOgBlAHYAZQBuAG8AZABkADsAIABjAGwAaQBwAC0AcgB1AGwAZQA6AGUAdgBlAG4AbwBkAGQAIgANAAoAdgBpAGUAdwBCAG8AeAA9ACIAMAAgADAAIAAzADUAMAAwADAAIAAzADUAMAAwADAAIgANAAoAIAB4AG0AbABuAHMAOgB4AGwAaQBuAGsAPQAiAGgAdAB0AHAAOgAvAC8AdwB3AHcALgB3ADMALgBvAHIAZwAvADEAOQA5ADkALwB4AGwAaQBuAGsAIgA+AA0ACgAgADwAZABlAGYAcwA+AA0ACgAgACAAPABzAHQAeQBsAGUAIAB0AHkAcABlAD0AIgB0AGUAeAB0AC8AYwBzAHMAIgA+AA0ACgAgACAAIAA8ACEAWwBDAEQAQQBUAEEAWwANAAoAIAAgACAAIAAuAGYAaQBsADAAIAB7AGYAaQBsAGwAOgBuAG8AbgBlAH0ADQAKACAAIAAgACAALgBmAGkAbAAxACAAewBmAGkAbABsADoAIwBGAEYANgBFADAAMAB9AA0ACgAgACAAIAAgAC4AZgBpAGwAMgAgAHsAZgBpAGwAbAA6AHcAaABpAHQAZQB9AA0ACgAgACAAIABdAF0APgANAAoAIAAgADwALwBzAHQAeQBsAGUAPgANAAoAIAA8AC8AZABlAGYAcwA+AA0ACgAgADwAZwAgAGkAZAA9ACIAQwBhAHAAYQBfAHgAMAAwADIAMABfADEAIgA+AA0ACgAgACAAPABtAGUAdABhAGQAYQB0AGEAIABpAGQAPQAiAEMAbwByAGUAbABDAG8AcgBwAEkARABfADAAQwBvAHIAZQBsAC0ATABhAHkAZQByACIALwA+AA0ACgAgACAAPAByAGUAYwB0ACAAYwBsAGEAcwBzAD0AIgBmAGkAbAAwACIAIAB3AGkAZAB0AGgAPQAiADMANQAwADAAMAAiACAAaABlAGkAZwBoAHQAPQAiADMANQAwADAAMAAiAC8APgANAAoAIAAgADwAcABhAHQAaAAgAGMAbABhAHMAcwA9ACIAZgBpAGwAMQAiACAAZAA9ACIATQAzADIAOAA4ADAAIAAzADIAOAA4ADAAbAAtADEANQAzADgAMAAgADAAYwAtADgANAA5ADUALAAwACAALQAxADUAMwA4ADAALAAtADYAOAA4ADUAIAAtADEANQAzADgAMAAsAC0AMQA1ADMAOAAwACAAMAAsAC0AOAA0ADkANAAgADYAOAA4ADUALAAtADEANQAzADgAMAAgADEANQAzADgAMAAsAC0AMQA1ADMAOAAwACAAOAA0ADkANAAsADAAIAAxADUAMwA4ADAALAA2ADgAOAA1ACAAMQA1ADMAOAAwACwAMQA1ADMAOAAwAGwAMAAgADEANQAzADgAMAB6ACIALwA+AA0ACgAgACAAPABwAGEAdABoACAAYwBsAGEAcwBzAD0AIgBmAGkAbAAyACIAIABkAD0AIgBNADMANAA4ADgAMAAgADMANAA4ADgAMABsADAAIAAtADEANwAzADgAMABjADAALAAtADkANQA5ADkAIAAtADcANwA4ADIALAAtADEANwAzADcAOQAgAC0AMQA3ADMAOAAwACwALQAxADcAMwA3ADkAIAAtADkANQA5ADgALAAwACAALQAxADcAMwA4ADAALAA3ADcAOAAxACAALQAxADcAMwA4ADAALAAxADcAMwA3ADkAIAAwACwAOQA1ADkAOAAgADcANwA4ADIALAAxADcAMwA4ADAAIAAxADcAMwA4ADAALAAxADcAMwA4ADAAbAAxADcAMwA4ADAAIAAwAHoAbQAtADIAMAAwADAAIAAtADIAMAAwADAAbAAtADEANQAzADgAMAAgADAAYwAtADgANAA5ADUALAAwACAALQAxADUAMwA4ADAALAAtADYAOAA4ADUAIAAtADEANQAzADgAMAAsAC0AMQA1ADMAOAAwACAAMAAsAC0AOAA0ADkANAAgADYAOAA4ADUALAAtADEANQAzADgAMAAgADEANQAzADgAMAAsAC0AMQA1ADMAOAAwACAAOAA0ADkANAAsADAAIAAxADUAMwA4ADAALAA2ADgAOAA1ACAAMQA1ADMAOAAwACwAMQA1ADMAOAAwAGwAMAAgADEANQAzADgAMAB6ACIALwA+AA0ACgAgACAAPABwAGEAdABoACAAYwBsAGEAcwBzAD0AIgBmAGkAbAAyACIAIABkAD0AIgBNADEANAA3ADkAOAAgADEAMwA5ADEAMgBjADQAMQA3ACwAMAAgADcANQA1ACwAMwAzADgAIAA3ADUANQAsADcANQA1ACAAMAAsADQAMQA3ACAALQAzADMAOAAsADcANQA1ACAALQA3ADUANQAsADcANQA1ACAALQA0ADEANwAsADAAIAAtADcANQA2ACwALQAzADMAOAAgAC0ANwA1ADYALAAtADcANQA1ACAAMAAsAC0ANAAxADcAIAAzADMAOQAsAC0ANwA1ADUAIAA3ADUANgAsAC0ANwA1ADUAegBtAC0ANAA2ADQANwAgAC0ANQAxADIANgBsADcAMAA3ADMAIAAwACAAMAAgADEAMQA2ADYAMQAgAC0ANwA5ADQANQAgADAAIAAwACAALQAxADAANwA5ADAAYwAwACwALQA0ADcAOQAgADMAOQAyACwALQA4ADcAMQAgADgANwAyACwALQA4ADcAMQB6AG0ANwA2ADIANQAgADAAbAA3ADAANwAzACAAMABjADQAOAAwACwAMAAgADgANwAyACwAMwA5ADIAIAA4ADcAMgAsADgANwAxAGwAMAAgADEAMAA3ADkAMAAgAC0ANwA5ADQANQAgADAAIAAwACAALQAxADEANgA2ADEAegBtADcAOQA0ADUAIAAxADIAMgAxADMAbAAwACAAMgAyADgANQAgAC0AMQA2ADQANAAyACAAMAAgADAAIAAtADIAMgA4ADUAIAAxADYANAA0ADIAIAAwAHoAbQAwACAAMgA4ADMANwBsADAAIAAxADUAMAA3AGMAMAAsADQAOAAwACAALQAzADkAMgAsADgANwAxACAALQA4ADcAMgAsADgANwAxAGwALQAxADQANgA5ADgAIAAwAGMALQA0ADgAMAAsADAAIAAtADgANwAyACwALQAzADkAMQAgAC0AOAA3ADIALAAtADgANwAxAGwAMAAgAC0AMQA1ADAANwAgADEANgA0ADQAMgAgADAAegBtAC0AOQAxADIAOAAgADYANwA4AGwAMQA4ADEANQAgADAAYwAxADMANgAsADAAIAAyADQANwAsADEAMQAxACAAMgA0ADcALAAyADQANwBsADAAIAA0ADMANQBjADAALAAxADMANgAgAC0AMQAxADEALAAyADQANwAgAC0AMgA0ADcALAAyADQANwBsAC0AMQA4ADEANQAgADAAYwAtADEAMwA3ACwAMAAgAC0AMgA0ADgALAAtADEAMQAxACAALQAyADQAOAAsAC0AMgA0ADcAbAAwACAALQA0ADMANQBjADAALAAtADEAMwA2ACAAMQAxADEALAAtADIANAA3ACAAMgA0ADgALAAtADIANAA3AHoAbQAwACAALQAyADgAMwA4AGwAMQA4ADEANQAgADAAYwAxADMANgAsADAAIAAyADQANwAsADEAMQAyACAAMgA0ADcALAAyADQAOABsADAAIAA0ADMANQBjADAALAAxADMANgAgAC0AMQAxADEALAAyADQANwAgAC0AMgA0ADcALAAyADQANwBsAC0AMQA4ADEANQAgADAAYwAtADEAMwA3ACwAMAAgAC0AMgA0ADgALAAtADEAMQAxACAALQAyADQAOAAsAC0AMgA0ADcAbAAwACAALQA0ADMANQBjADAALAAtADEAMwA2ACAAMQAxADEALAAtADIANAA4ACAAMgA0ADgALAAtADIANAA4AHoAbQAzADYAMAA5ACAALQA3ADcANgA0AGMALQA0ADEANwAsADAAIAAtADcANQA1ACwAMwAzADgAIAAtADcANQA1ACwANwA1ADUAIAAwACwANAAxADcAIAAzADMAOAAsADcANQA1ACAANwA1ADUALAA3ADUANQAgADQAMQA3ACwAMAAgADcANQA2ACwALQAzADMAOAAgADcANQA2ACwALQA3ADUANQAgADAALAAtADQAMQA3ACAALQAzADMAOQAsAC0ANwA1ADUAIAAtADcANQA2ACwALQA3ADUANQB6ACIALwA+AA0ACgAgADwALwBnAD4ADQAKADwALwBzAHYAZwA+AA0ACgA=";
		}
		if (!nombre) {
			nombre = 'test.svg';
		}
		if (!tipo) {
			tipo = 'image/svg+xml';
		}
		return this.sws.subirBase64CMS(b64, nombre, tipo).toPromise();
	}

	parsearImagesHTML(){
		// https://www.regextester.com/103676
		const html = '<p>Recepcion Insur</p><p>Amarillo</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="></p><p>Azul</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkSPxfDwADqgHh5Lh3ywAAAABJRU5ErkJggg=="></p><p>Rojo</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z2BaDwAE7wG1mWe+NgAAAABJRU5ErkJggg=="></p><p><br></p>';
		const regex = /<img[^>]+src="data:image\/(.*?);base64,(.*?)"[^\>]*>/g;
		let m;
		const urls = [];
		const tipos = [];
		while ( m = regex.exec( html ) ) {
			tipos.push(m[1]);
			urls.push( m[2] );
		}
		for (let index = 0; index < urls.length; index++) {
			const url = urls[index];
			const tipo = 'image/' + tipos[index];
			this.subirBase64(url, Math.floor(Date.now() / 1000) + '', tipo)
			.then(urlImagen => {
				console.log('URL_IMAGEN = ' + urlImagen);
				this.DIAG.escribir(1, 'Imagen: ', 'BreezeBody');
				this.DIAG.escribir(1, '-------------------------------------------', 'BreezeBody');
				this.DIAG.escribir(1, 'url: ' + urlImagen , 'BreezeBody');
			});
		}
		return urls;
	}

	subirFicherosFromHTML(){
		const html = '<p>Recepcion Insur</p><p>Amarillo</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="></p><p>Azul</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkSPxfDwADqgHh5Lh3ywAAAABJRU5ErkJggg=="></p><p>Rojo</p><p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z2BaDwAE7wG1mWe+NgAAAABJRU5ErkJggg=="></p><p><br></p>';
		const files = this.sws.filesFromHTML(html);
		this.sws.subidaFicherosCMS(files)
		.then(function (msg) {
			console.log('FICHEROS SUBIDOS: ');
			console.log(msg);
		})
		.catch(function (error) {
			console.error('FICHEROS SUBIDOS: ');
		});
	}
	*/
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/BreezeTest/BreezeTest.component.ts